import React, { Component } from 'react';

import styles from './Home.module.less';

export default class Home extends Component {
  render() {
    return (
      <div>
        <div className={styles.container}>
          <h1>Enzo</h1>
          <p>discover where you want to travel next</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Home.js